import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import "./home.scss";
function Home({ background, time, paragraph, heading, more }) {
	AOS.init({
		delay: time // values from 0 to 3000, with step 50ms
	});
	const image = new Image()
	image.src = background

	useEffect(()=>{
		console.log(image.src,'imageimage')
	},[image])
	return (
		<div className="innerHome">
			<div className="sec1">
				<div className="serveForm" style={{ backgroundImage: `url(${image.src})` }}>
					<div className="container row">
						<div className="sec1Content col-lg-7 col-md-12 col-sm-12">
							<div className="sec1Head">
								<h6 className="small-title" data-aos="fade-up">
									{paragraph ? paragraph : "CERTIFIED GEMSTONES TESTING"}
								</h6>
								{heading ? (
									heading
								) : (
									<h2 data-aos="fade-down">
										MOST TRUSTED
										<br />
										<span data-aos="fade-right">
											DIAMOND & <br /> GEM{" "}
										</span>{" "}
										IDENTIFICATION
									</h2>
								)}
								<div className="buttonFlex">
									<Link to="/about" data-aos="fade-up-right">
										<button className="learnMore">LEARN MORE</button>
									</Link>
									<Link to="/about" data-aos="fade-up-right">
										{" "}
										<button className="contactUs">ABOUT US</button>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
